import { Helper } from "../util/helper.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import React from "react";

export class DatePicker extends React.Component<DatePickerProps, any>{
    private datePickerRef: any;
    private datePicker: kendo.ui.DatePicker;
    private value: any;
    private disabled = true;


    public getDatePickerRef = () => {
        return this.datePicker;
    }


    componentWillUnmount() {
        this.datePicker.destroy();
    }

    componentDidMount() {
        this.disabled = this.props.disabled || false;
        this.value = this.props.value;
        this.datePicker = $(this.datePickerRef).kendoDatePicker({
            parseFormats: ["yyyy-MM-dd", "dd.MM.yyyy"],
            value: this.value,
            weekNumber: true,

            change: (ev) => {
                this.value = ev.sender.value();
                this.props.onChange(this.props.field, Helper.dates.getISODateString(this.value, Helper.getValueOrDefault(this.props.field.clearTime, false)), null);
            }
        }).data("kendoDatePicker");
        this.datePicker.readonly(this.disabled);
        this.datePicker.wrapper.attr("data-readonly", this.disabled.toString());
        if (this.props.field.focus)
            this.datePicker.element.focus();

        if (!Helper.isNullOrEmpty((this.props.field.min || "").toString())) {
            this.datePicker.min(Helper.dates.toDate(this.props.field.min))
        }

        if (!Helper.isNullOrEmpty((this.props.field.max || "").toString())) {
            this.datePicker.max(Helper.dates.toDate(this.props.field.max))
        }

    }

    componentDidUpdate(prevProps, prevState) {
        const isDisabled = this.props.disabled || false;
        if (this.disabled !== isDisabled) {
            this.disabled = isDisabled;
            this.datePicker.readonly(this.disabled);
            this.datePicker.wrapper.attr("data-readonly", this.disabled.toString());
        }

        if (Helper.dates.compareMultiTypeDates(this.value, this.props.value, true) !== 0) {
            this.value = this.props.value;
            this.datePicker.value(this.value);
        }

        if ((Helper.dates.compareMultiTypeDates(this.datePicker.min(), (this.props.field.min || ""), true) !== 0)) {
            this.datePicker.min(Helper.dates.toDate(this.props.field.min))
        }

        if ((Helper.dates.compareMultiTypeDates(this.datePicker.max(), (this.props.field.max || ""), true) !== 0)) {
            this.datePicker.max(Helper.dates.toDate(this.props.field.max))
        }
    }

    render() {
        return (
            <input ref={(r) => this.datePickerRef = r} name={this.props.field.model} style={{ width: "100%" }} required={this.props.required} data-label={this.props.field.name} />
        );
    }
}

export interface DatePickerProps extends BaseComponentProps {
    field: DatePickerField
}

interface DatePickerField extends BaseField {
    focus?: boolean;
    clearTime?: boolean;
    min?: string | Date
    max?: string | Date
}